<template>
  <div :data-testid="starCountVisualizerBg" class="star-count-visualizer-bg" aria-hidden="true">
    <div class="star-count-visualizer-fill" :style="`width: ${value}%`" :data-testid="starCountVisualizerFill"></div>
  </div>
</template>

<script setup lang="ts">
import { starCountVisualizerBg, starCountVisualizerFill } from '../../constants/testIds';

defineProps<{
  value: number;
}>();
</script>

<style scoped lang="scss">
.star-count-visualizer-bg {
  position: relative;
  height: rem-calc(12);
  background-color: $gray-5-color;
  overflow: hidden;
}
.star-count-visualizer-fill {
  position: absolute;
  height: 12px;
  background-color: $black;
}
</style>


